<div class="description">
    <p>
        Before you schedule interviews from the system, you need to enable a calendar integration. This will allows us
        to retrieve free / busy information.
    </p>
</div>

<div class="select-service">
    <h3>Select a Service</h3>

    <div class="services-list">
        <button
            class="service-item"
            *ngFor="let service of servicesList"
            [disabled]="!service.enabled"
            [ngClass]="{ active: activeService === service.title }"
            (click)="selectScheduleService(service.id)"
        >
            <img [src]="service.icon" [alt]="service.title" />
            <span>{{ service.title }}</span>
        </button>
    </div>

    <div class="next-step flex-row jcc">
        <button class="btn btn-primary" [disabled]="!nextEnabled" (click)="goToNextStep()">
            Next
        </button>
    </div>
</div>
